<div class="flex items-center justify-center gap-4">
  <button type="button" (click)="decrement()" [disabled]="!canDecrement"
    [attr.aria-label]="decreaseLabel || ('common.decrease' | translate)"
    class="flex h-11 w-11 shrink-0 items-center justify-center rounded-field bg-vw-surface-tint text-2xl font-semibold leading-none text-vw-primary transition-transform active:scale-95 active:bg-vw-line disabled:opacity-40">−</button>

  <div class="flex min-w-[64px] flex-col items-center" aria-live="polite" aria-atomic="true">
    @if (editable) {
      <!-- Sélectionné en entier au toucher : on tape 50 sans effacer le 1. -->
      <input type="number" inputmode="numeric" enterkeyhint="done" [min]="min" [attr.max]="max ?? null" [value]="value"
        [attr.aria-label]="inputLabel || unitLabel || null" (focus)="input.select()" (change)="onTyped(input)" (keydown.enter)="input.blur()" #input
        class="w-20 rounded-field border border-vw-line bg-vw-surface text-center text-display font-bold text-vw-ink focus:border-vw-primary focus:outline-none" />
    } @else {
      <span class="text-3xl font-bold leading-none text-vw-ink">{{ value }}</span>
    }
    @if (unitLabel) {
      <span class="mt-1 text-xs font-medium text-vw-muted">{{ unitLabel }}</span>
    }
  </div>

  <button type="button" (click)="increment()" [disabled]="!canIncrement"
    [attr.aria-label]="increaseLabel || ('common.increase' | translate)"
    class="flex h-11 w-11 shrink-0 items-center justify-center rounded-field bg-vw-surface-tint text-2xl font-semibold leading-none text-vw-primary transition-transform active:scale-95 active:bg-vw-line disabled:opacity-40">+</button>
</div>
